import { useFormik } from "formik";
import { useEffect, useState } from "react";

// Internal Imports
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import { IFormQuetionGroup } from "../../../interfaces/IForm";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import useListGroupQuestion from "../../../hooks/useListGroupQuestion";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import Paint from "../../../common/components/Paint/Paint";
import { returnOrdenSelection } from "../../../common/constants/Utilities";
import OutLineButton from "../../../common/components/OutLineButton/OutLineButton";
import DetailTable from "../../../common/components/DetailTable/DetailTable";
import IColumn from "../../../interfaces/IColumn";
import ButtonGrid from "../../../common/components/ButtonGrid/ButtonGrid";
import { DeleteOutlined, FormOutlined, RollbackOutlined } from "@ant-design/icons";
import Modal from "../../../common/components/Modal/Modal";
import AddUpdateQuestionGroup from "../../GrupoPreguntas/AddUpdateQuestionGroup";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    setCanGoBack: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}


const StepTwo = ({ setCanGoNext, setCanGoBack, mode }: Props) => {

    // States
    const { formQuestion, setFormQuestion } = useForm();
    const [detailUpdate, setDetailUpdate] = useState<IFormQuetionGroup>();
    const [groupQuestionList, setGroupQuestionList] = useState<IFormQuetionGroup[]>([]);
    const { loadingListGroupQ, listGroupQuestion, setListGroupQuestion } = useListGroupQuestion();

    // Modal ShortCut Add GroupQuestion
    const { listDepartment, loadingDeparment } = useListDepartmentByUer();
    const [visibleModal, setVisibleModal] = useState<boolean>(false);


    // Const
    const columns: IColumn[] = [
        {
            title: 'Grupo',
            dataIndex: 'grupoPreguntaNombre',
        },
        {
            title: 'Orden',
            dataIndex: 'orden',
        },

        {
            title: "",
            dataIndex: "",
            render: (detail: IFormQuetionGroup) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonGrid color={COLORS.black_text_color4} active={detailUpdate?.grupoPreguntaID !== detail.grupoPreguntaID && !!detailUpdate ? false : true} icon={detailUpdate?.grupoPreguntaID === detail.grupoPreguntaID ? <RollbackOutlined /> : <FormOutlined />} method={() => selectDetail(detail)} />
                    <nav>&nbsp;&nbsp;</nav>
                    <ButtonGrid color={COLORS.black_text_color4} active={!detailUpdate} icon={<DeleteOutlined />} method={() => removeDetail(detail.grupoPreguntaID)} />
                </div>
            )
        }
    ];

    // Methods
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.grupoPreguntaID) {
            errors.grupoPreguntaID = 'Requerido';
        }

        if (!values.orden) {
            errors.orden = 'Requerido';
        }

        return errors;
    }


    const clearForm = () => {
        FormQuestionFormik.setValues({
            grupoPreguntaID: "",
            orden: "",
            grupoPreguntaNombre: ""
        })
    }

    const addDetail = () => {
        const newGroupQ: IFormQuetionGroup = {
            formularioGrupoPreguntaID: 0,
            formularioID: formQuestion!.formularioID,
            grupoPreguntaID: parseInt(FormQuestionFormik.values.grupoPreguntaID),
            grupoPreguntaNombre: listGroupQuestion.find(group => group.grupoPreguntaID!.toString() === FormQuestionFormik.values.grupoPreguntaID)!.nombre!,
            orden: parseInt(FormQuestionFormik.values.orden)
        }

        let listInternal = formQuestion!.formularioGrupoPregunta!;
        listInternal.push(newGroupQ);

        setFormQuestion({ ...formQuestion!, formularioGrupoPregunta: listInternal! });
        clearForm();
    }

    const selectDetail = (groupQuestion: IFormQuetionGroup) => {
        if (!!!detailUpdate) {
            setDetailUpdate(groupQuestion);

            FormQuestionFormik.setValues({
                grupoPreguntaID: groupQuestion.grupoPreguntaID.toString(),
                orden: groupQuestion.orden.toString(),
                grupoPreguntaNombre: groupQuestion.grupoPreguntaNombre
            });

        } else {
            setDetailUpdate(undefined);
            clearForm();
        }
    }

    const updateDetail = () => {
        let internal: IFormQuetionGroup = {
            formularioGrupoPreguntaID: detailUpdate?.formularioGrupoPreguntaID!,
            formularioID: detailUpdate!.formularioID,
            grupoPreguntaID: parseInt(FormQuestionFormik.values.grupoPreguntaID),
            grupoPreguntaNombre: listGroupQuestion.find(group => group.grupoPreguntaID?.toString() === FormQuestionFormik.values.grupoPreguntaID)!.nombre!,
            orden: parseInt(FormQuestionFormik.values.orden)
        }

        let listInternal = formQuestion!.formularioGrupoPregunta!;
        let index = listInternal.findIndex(x => x.grupoPreguntaID === detailUpdate!.grupoPreguntaID);

        listInternal[index] = internal!;

        setFormQuestion({ ...formQuestion!, formularioGrupoPregunta: [...listInternal!] });

        // Finally
        setDetailUpdate(undefined);
        clearForm();
    }

    const removeDetail = (groupQtId: number) => {
        const listInternal = formQuestion!.formularioGrupoPregunta!.filter(groupQ => groupQ.grupoPreguntaID !== groupQtId);
        setFormQuestion({ ...formQuestion!, formularioGrupoPregunta: [...listInternal!] });
    }

    // Form
    const FormQuestionFormik = useFormik({
        initialValues: { grupoPreguntaID: "", orden: "", grupoPreguntaNombre: "" },
        validate: validations,
        onSubmit: () => !!detailUpdate ? updateDetail() : addDetail(),
    })

    // Effects
    useEffect(() => {
        if (!!formQuestion && formQuestion?.formularioGrupoPregunta!.length > 0) {
            setGroupQuestionList([...formQuestion?.formularioGrupoPregunta!]);
        } else {
            setGroupQuestionList([]);
        }
    }, [formQuestion]);


    useEffect(() => {
        if (!!detailUpdate) {
            setCanGoNext(false);
            setCanGoBack(false)
        } else {
            setCanGoNext(true);
            setCanGoBack(true)
        }
    }, [detailUpdate]);


    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Grupo:</label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
                        <SelectBox
                            value={FormQuestionFormik.values.grupoPreguntaID}
                            placeholder={"Grupo pregunta"}
                            disabled={false}
                            allowClear={false}
                            loading={loadingListGroupQ}
                            onChange={(value: string) => FormQuestionFormik.setFieldValue("grupoPreguntaID", value)}
                            options={listGroupQuestion.filter(groupQ => groupQ.departamentoGUID === formQuestion?.departamentoGUID && (!formQuestion!.formularioGrupoPregunta!.map(x => x.grupoPreguntaID).includes(groupQ.grupoPreguntaID!) || groupQ.grupoPreguntaID === detailUpdate?.grupoPreguntaID)).map(attr => ({ key: attr.nombre, value: attr.grupoPreguntaID?.toString(), text: attr.nombre }))}
                            backgroundColor={COLORS.white_color2(1)}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                        />
                        <nav className="addShortCut" onClick={() => setVisibleModal(true)}><i className="fa-solid fa-plus"></i></nav>
                    </div>
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.grupoPreguntaID && FormQuestionFormik.errors.grupoPreguntaID}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Orden:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.orden}
                        placeholder={"Orden"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingListGroupQ}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue("orden", value)}
                        options={returnOrdenSelection(detailUpdate?.orden.toString() || '', formQuestion?.formularioGrupoPregunta)}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.orden && FormQuestionFormik.errors.orden}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                    <MarginInput width="40%">
                        <OutLineButton color={!!detailUpdate ? COLORS.white_color1 : COLORS.blue_active} backgroundColor={!!detailUpdate ? COLORS.blue_main(1) : COLORS.transparent_color1} text={!!detailUpdate ? "Modificar Grupo Pregunta" : "Añadir Grupo Pregunta"} method={FormQuestionFormik.handleSubmit} />
                    </MarginInput>
                </div>
                <DetailTable
                    props={{ rowKey: (record: IFormQuetionGroup) => record.grupoPreguntaNombre }}
                    dataSource={groupQuestionList}
                    columns={columns}
                    loading={false}
                    paginationActive={!detailUpdate}
                />
            </div>

            <Modal props={{ style: { top: '-45px' } }} width={"50%"} title={<nav className="modal_title">Crear <Paint color={COLORS.blue_main(1)}>Grupo de Preguntas</Paint></nav>} visible={visibleModal} setVisible={setVisibleModal} askBeforeClose={false}>
                <AddUpdateQuestionGroup defaultDepartmentGUID={formQuestion?.departamentoGUID} setDataList={setListGroupQuestion} dataList={listGroupQuestion} questionGroupUpdate={undefined} mode={'Add'} setQuestionGroupUpdate={undefined} setAddUpdateModal={setVisibleModal} listDepartment={listDepartment} loadingDeparment={loadingDeparment} />
            </Modal>

        </div>
    );
}

export default StepTwo;